import Vue from 'vue';
import Vuetify from 'vuetify';
import BaiduMap from 'vue-baidu-map';

import App from './App.vue';
import { router } from './router';
import store from '@/store';
import 'vuetify/dist/vuetify.min.css';
// for IE message
import '@babel/polyfill';

import i18n from '@/plugins/i18n';

import unitModule from '@/views/unit/store/unit.module';
import specificationModule from '@/views/specification/store/specification.module';
import commonModule from '@/views/common/store/common.module';
import LandingModule from '@/views/landing/store/landing.module';

Vue.config.productionTip = false;

Vue.use(Vuetify, {
  theme: {
    primary: '#154281',
    secondary: '#5a78a3',
    lightBlue: '#afc7ff',
    tertiary: '#004c99',
    lightBlueGrey: '#cbd1d8',
    blueGrey: '#485465',
    darkGrey: '#5c6670',
    bg: '#f4f8fc',
    marine: '#103467',
    truetzschlerNavy: '#154281',
    antrahzit: '#464646',
    navy: '#004687',
    lightNavy: '1961AC'
  },
  options: {
    customProperties: true
  }
});

Vue.use(BaiduMap, {
  ak: Vue.config.baiduApiKey
});

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
  created() {
    let currentLanguage = localStorage.getItem('currentLanguage');
    if (currentLanguage) {
      i18n.locale = currentLanguage;
    }
    store.registerModule('unitState', unitModule);
    store.registerModule('specificationState', specificationModule);
    store.registerModule('commonState', commonModule);
    store.registerModule('landingState', LandingModule);
  }
}).$mount('#app');
